export default function Lineup() {
  const products = [
    {
      name: 'Spring Sun Bowl 雅\n第一世代',
      nameEn: 'Sakura',
      price: '¥10,000（税抜）',
      color: 'bg-pink-100',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/1b08ad1f2f1316d46d77063174e70e53.png'
    },
    {
      name: 'Spring Sun Bowl 雅(低温)\n第二世代',
      nameEn: 'Hisui',
      price: '¥10,000（税抜）',
      color: 'bg-emerald-100',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/1b08ad1f2f1316d46d77063174e70e53.png'
    },
    {
      name: 'Spring Sun Bowl 雅(中温)\n第二世代',
      nameEn: 'Sumi',
      price: '¥10,000（税抜）',
      color: 'bg-gray-200',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/1b08ad1f2f1316d46d77063174e70e53.png'
    },
    {
      name: 'Spring Sun Bowl 雅(高温)\n第二世代',
      nameEn: 'Kohaku',
      price: '¥10,000（税抜）',
      color: 'bg-amber-100',
      image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/1b08ad1f2f1316d46d77063174e70e53.png'
    }
  ];

  return (
    <section id="lineup" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-2">ラインナップ</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div 
              key={index}
              className={`${product.color} rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer`}
            >
              <div className="p-8 h-96 flex items-center justify-center">
                <div className="w-full h-full">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
              <div className="bg-white p-6 text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-1 whitespace-pre-line">{product.name}</h3>
                <p className="text-amber-600 font-semibold text-lg">{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
